<kendo-dialog id="serviceDialogModel" title="{{'_General_LWA_Text_' | translate }}" *ngIf="dialogOpened" (close)="close()"
    [minWidth]="250" [width]="600">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <div class="psPanel col-md-12">
        <div>
            <p>{{'_Shared_ModalPopUp_LWA_To_Remove_Text_' | translate }} {{lwaObject.firstName}} {{lwaObject.lastName}} {{'_Shared_ModalPopUp_LWA_From_Text_' | translate }}
                {{lwaObject.locationName}} {{'_Shared_ModalPopUp_LWA_Select_LWA_Text_' | translate }}</p>
        </div>

        <div class="ps-list">
            <ul>
                <li *ngFor="let reason of allLWAResons; let i = index;" class="radio">
                    <label>
                        <input [id]="'lwa' +i" type="radio" (change)="checkedChange(i)" [checked]="(i === 0)"
                            [value]="reason.id" kendoRadioButton class="k-radio" name="lwa_reason">
                        {{reason.reason}}
                    </label>
                </li>
            </ul>

        </div>
    </div>

    <div class="col-md-12">
        <label for="notes">{{'_Shared_ModalPopUp_LWA_Comments_Text_' | translate }}</label>
        <div class="cc-textarea-container">
            <div class="cc-textarea">
                <textarea [(ngModel)]="comment" maxlength="300" id="reason" class="form-control" rows="3" app-filter
                    pattern="^[^><&]*$"></textarea>
            </div>
        </div>
    </div>
    <kendo-dialog-actions class="cc-btn-panel">
        <button id="modalCancel" class="btn btn-secondary" (click)="close()">{{'_General_Button_Cancel_Text_' | translate }}</button>
        <button id="modalSubmit" class="btn btn-primary" (click)="submitLeftWithoutAssistant()"
            [disabled]="selectedLWAResons==null">{{'_General_Button_Save_Text_' | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>
